(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pingOidc", [], factory);
	else if(typeof exports === 'object')
		exports["pingOidc"] = factory();
	else
		root["pingOidc"] = factory();
})(self, () => {
return 